import { Routes } from '~/constants/routes';
import { isPathnameOrNested } from '~/utils/isPathnameOrNested';

export const SETTINGS_SUB_SIDE_NAV_PATHNAMES = [
  ...Object.values(Routes.workspaceAdmin),
  Routes.workspaceSettings.members,
  Routes.account.apiAccess,
  Routes.account.myAccount,
  Routes.account.changePassword,
  Routes.account.notificationSettings,
  Routes.account.integrations,
] as const;

export const isSettingsSubSideNavPathname = (pathname: string) =>
  SETTINGS_SUB_SIDE_NAV_PATHNAMES.some((settingsPathname) => isPathnameOrNested(pathname, settingsPathname));
